import _styled from "styled-components";
var _excluded = ["active", "number", "size"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { ButtonInner } from "../ButtonInner/ButtonInner";
import * as styles from "./styles";
/**
 * SingleNumberButton takes a number as a prop and returns a button
 * This component is useful for pagination purposes
 */
export var SingleNumberButton = function SingleNumberButton(_ref) {
  var active = _ref.active,
    number = _ref.number,
    size = _ref.size,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_StyledButton, _extends({
    "data-is-active": active
  }, props, {
    $_css: [size === 'small' ? styles.small : styles.large, styles.singleNumberButton]
  }), /*#__PURE__*/React.createElement(ButtonInner, null, number));
};
var _StyledButton = /*#__PURE__*/_styled("button").withConfig({
  displayName: "SingleNumberButton___StyledButton",
  componentId: "sc-o0w7da-0"
})(["", ""], function (p) {
  return p.$_css;
});